export default "__VITE_ASSET__BGrFngsj__"